import PropTypes from 'prop-types';

const PublisherDisplayItem = ({ name }) => {
  return <li className='py-1 px-3 rounded-md hover:bg-[#1b43321f] cursor-default'>{name}</li>;
};

PublisherDisplayItem.propTypes = {
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PublisherDisplayItem;
